gsap.registerPlugin(ScrollTrigger);
document.addEventListener("DOMContentLoaded", () => {

    const isTouch = 'ontouchstart' in window;
    const headings = gsap.utils.toArray(".mag-hero__ttl");
    const headingsSpan = document.querySelector(".mag-hero__ttl span");
    const section = document.querySelector('.mag-hero');
    const header = document.querySelector('#header-block');
    const headerItem = document.querySelector('.site-header');
    const intro = document.querySelector('.mag-hero__intro');
    const scrollerSVG = document.querySelector('.mag-hero__scroller svg');
    const scrollerLabel = document.querySelector('.mag-hero__scroller-label');

    const heroContent = document.querySelector('.mag-hero__content');
    const breadcrumb = document.querySelector('.bc');

    if (!isTouch) {
        window.onresize = function () {
            ScrollTrigger.refresh();
        }
    }


    function getParameterByName(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    function shortAnim() {
        document.body.style.overflow = "auto";
        document.body.style.overflowX = "hidden";
        headerItem.classList.add("dark");
        breadcrumb.classList.add("dark");
        const tl = gsap.timeline({ delay: 0.7 });
        tl.to(section, { backgroundColor: "#222", duration: 0.3 })
        .to('.mag-hero__ttl', {
            backgroundImage: "linear-gradient(90deg, #EBE7DD 100%, #ee7c30 200%, #0eafe0 300%, #69ca00 400%, #222 500%)",
            duration: 0.3,
            ease: "power1.inOut"
        }, '<')        
        .to(headingsSpan, {
            backgroundImage: "linear-gradient(90deg,#ebe7dd -100%, #f9b500 0%, #f9b500 14.78%, #69ca00 47.29%, #69ca00 55.17%, #0eafe0 88.18%, #0eafe0 100%)",
            duration: 0.3,
            ease: "power1.inOut"
        }, '<')
        setTimeout(() => {
            const targetElement = document.querySelector('#chipset-block');
            if (targetElement) {

                
                window.scrollTo({
                    top: (document.body.scrollHeight / 2) - 650 ,
                    behavior: 'smooth' // Optional: Makes the scroll smooth
                  });
            }
            return;
        }, 500);
    }

    function longAnim() {
        document.body.style.overflow = "hidden";
        document.body.style.overflowX = "hidden";

    
        /////// Hero section animation for both mobile and desktop ////////
        headings.forEach((element) => {
            const tl = gsap.timeline({ delay: 0.7 });
    
            tl.to([element], {
                x: -20,
                duration: 0.7,
                ease: "power1.In",
            }, 0)
                .to(element, {
                    backgroundImage: "linear-gradient(90deg, #222 -500%, #ee7c30 -400%, #0eafe0 -300%, #69ca00 -200%, #222 -100%)",
                    duration: 1,
                    ease: "none"
                })
                .to(element, {
                    x: 0,
                    duration: 1,
                    ease: "power1.Out"
                })
                .to(element, {
                    backgroundImage: "linear-gradient(90deg, #EBE7DD 100%, #ee7c30 200%, #0eafe0 300%, #69ca00 400%, #222 500%)",
                    duration: 1,
                    ease: "none",
                    onComplete: () => headingsSpan.classList.add("gradient")
                }, '<')
                .to(section, {
                    backgroundColor: "#222",
                    duration: 1,
                    ease: "power1.Out",
                    onStart: () => {
                        headerItem.classList.add("dark");
                        breadcrumb.classList.add("dark");
                    }
                }, '<')
                .to(header, {
                    y: 0,
                    duration: 0.6,
                    ease: "power1.Out"
                })
                .to(breadcrumb, {
                    y: 0,
                    duration: 0.6,
                    ease: "power1.Out"
                }, '<')
                .to([heroContent, intro], {
                    y: (i) => i === 0 ? -150 : -30,
                    opacity: (i) => i === 1 ? 1 : null,
                    duration: 1,
                    ease: "power1.inOut"
                })
                .to(headingsSpan, {
                    backgroundImage: "linear-gradient(90deg,#ebe7dd -100%, #f9b500 0%, #f9b500 14.78%, #69ca00 47.29%, #69ca00 55.17%, #0eafe0 88.18%, #0eafe0 100%)",
                    duration: 1,
                    ease: "power1.inOut"
                }, '<')
                .to([scrollerLabel, scrollerSVG], {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    delay: 1,
                    ease: "power1.Out",
                    onComplete: () => {
                        document.body.style.overflow = "auto";
                        document.body.style.overflowX = "hidden";
                    }
                }, "<");
        });        
    }

    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            shortAnim();
        }
    });
    
    // Example usage:
    if (getParameterByName('stories')) {
        shortAnim();

    } else {
        longAnim();
    }
});